import styled, { css, keyframes } from 'styled-components'

const barCodeAnimation = keyframes`
  0% { top: 0; opacity: 0; }
  30% { top: 0; opacity: 0; }
  50% {  opacity: 0.4; }
  70% { top: 100%; opacity: 0; }
  100% { top: 100%; opacity: 0; }
`

export const ScannerLogo = styled.div`
  margin: 0vh auto 5vh;
  img {
    height: 8rem;
  }
`

export const ScannerIndicatorIcon = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 6.5rem;
  height: 5rem;
  margin-bottom: 2rem;

  &:after {
    position: absolute;
    top: 0;
    height: 2px;
    left: 0;
    right: 0;
    content: ' ';
    background-color: currentColor;
    animation: ${barCodeAnimation} infinite 3s;
  }

  svg {
    display: block;
    width: 80%;
    height: 80%;
    fill: currentColor;
  }
`

export const ScannerIndicatorWrapper = styled.div`
  text-align: center;
  position: relative;
  h5 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 0;
  }

  ${props =>
    props.size === 'small' &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column-reverse;
      margin: 1rem auto;

      h5 {
        font-size: 0.85rem;
      }

      ${ScannerIndicatorIcon} {
        margin-bottom: 0;
        width: 2.5rem;
        height: 2rem;
        margin-top: 0.5rem;

        &:after {
          height: 1px;
        }
      }
    `};
`

export const ScannerFooter = styled.div`
  margin-top: auto;
  width: 100%;
`

export const ScannerVendor = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  text-align: center;

  span {
    display: block;
    color: var(--color-muted-inverted);
    font-weight: 500;
    margin-bottom: 0.5rem;
  }

  img {
    height: 4rem;
  }
`

export const ScannerWrapper = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${ScannerIndicatorWrapper} {
    margin-top: auto;
    margin-bottom: 4rem;
  }
`

export const BrowseProductsButton = styled.button`
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  margin: 2rem auto 0;
  transition: all 0.3s ease;
  display: block;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
  }
`
